import React, { forwardRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { GetHistoryItem } from "../../../APIServices/SalesService/DeliveryService/deliveryHistory";
import { GetInvoiceItems } from "../../../APIServices/SalesService/InvoiceService/invoiceThunk";
import { toast, Toaster } from 'react-hot-toast';
import './historyPage.css'
  const HistoryList = ({ type,value, historyData, setInProgress }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDelivery = type === "delivery";
  const handleClick = async(item) => {
    sessionStorage.setItem("type", type);
    if (isDelivery) {
      setInProgress(prev => ({ ...prev, deliveryItems: true }));
    } else {
      setInProgress(prev => ({ ...prev, invoiceItems: true }));
    }
    const fetchAction = isDelivery
      ? GetHistoryItem({ DocEntry: item.doc_Entry,value })
      : GetInvoiceItems({ DocEntry: item.doc_Entry });
      // await dispatch(fetchAction).unwrap();
      // navigate("/sales/HistoryItems");
      try {
        await dispatch(fetchAction).unwrap();
        navigate("/sales/HistoryItems");
      } catch (error) {
        // Show toast error message here
        // toast.error(error.errorMessage || "Something went wrong!");
        // Optionally, reset inProgress flags here if needed
  
  };
  }
  return (
<  >
<div className="history-list-container">
  {
  // historyData && historyData.length > 0 ? (
    historyData?.map((item) => (
      <div
        className="HistoryItem"
        key={item.doc_Entry}
        onClick={() => handleClick(item)}
      >
        <div className="HistoryLeft">
          <p>Doc#{item.order_No}</p>
          {value==="Loading"&&
          <p>PickList No - {item.doc_Entry}</p>
          }
          <p className="itemname">{item.card_Name}</p>
          <p>{item.order_Date}</p>
        </div>
        <div className="HistoryRight">
          <p
            className={`status-badge ${
              item.status === "Open" ? "open" : "close"
            }`}
          >
            {item.status}
          </p>
          <p className="order-value">
            Rs:{Number(item.doc_Total).toLocaleString("en-IN")}
          </p>
        </div>
        <div className="IconRight">
          <FaChevronRight size={14} />
        </div>
      </div>
    ))
  // ) : (
  //     <div className="no-orders-container">
  //         <p className="no-orders-message">No data found</p>
  //       </div>
  // )
  }

  <Toaster
    position="top-center"
    toastOptions={{
      style: {
        fontSize: "16px",
        padding: "16px",
        width: "400px",
        borderRadius: "8px",
      },
    }}
  />
</div>
    </>
);
};

export default HistoryList;





// historyList.jsx
// import React from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { FaChevronRight } from "react-icons/fa";
// import { GetHistoryItem } from "../../../APIServices/SalesService/DeliveryService/deliveryHistory";
// import { GetInvoiceItems } from "../../../APIServices/SalesService/InvoiceService/invoiceThunk";
// import { toast, Toaster } from 'react-hot-toast';
// import './historyPage.css';

// const HistoryList = ({ type, historyData, Errors, setInProgress }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const isDelivery = type === "delivery";

//   const handleClick = (item) => {
//     sessionStorage.setItem("type", type);
//     if (isDelivery) {
//       setInProgress(prev => ({ ...prev, deliveryItems: true }));
//     } else {
//       setInProgress(prev => ({ ...prev, invoiceItems: true }));
//     }

//     const fetchAction = isDelivery
//       ? GetHistoryItem({ DocEntry: item.doc_Entry })
//       : GetInvoiceItems({ DocEntry: item.doc_Entry });

//     dispatch(fetchAction).then(() => {
//       if (!Errors) navigate("/sales/HistoryItems");
//     });
//   };

//   return (
//     <>
//       {historyData?.map((item) => (
//         <div className="HistoryItem" key={item.doc_Entry} onClick={() => handleClick(item)}>
//           <div className="HistoryLeft">
//             <p>Doc#{item.order_No}</p>
//             <p className='itemname'>{item.card_Name}</p>
//             <p>{item.order_Date}</p>
//           </div>
//           <div className="HistoryRight">
//             <p className={`status-badge ${item.status === 'Open' ? 'open' : 'close'}`}>{item.status}</p>
//             <p className="order-value">Rs:{Number(item.doc_Total).toLocaleString('en-IN')}</p>
//           </div>
//           <div className="IconRight">
//             <FaChevronRight size={14} />
//           </div>
//         </div>
//       ))}
//       <Toaster />
//     </>
//   );
// };

// export default HistoryList;

